<template>
    <q-card
        :class='["uploadArea q-pa-sm", {small: small, draggingOver: draggingOver}]'
        :inline="inline"
        @dragover.native.prevent="() => {draggingOver = true}"
        @dragleave.native.prevent="() => {draggingOver = false}"
        @dragenter.native.prevent="() => {}"
        @drop.native.prevent="(e) => {drop(e)}"
    >
        <slot>
            <div class="text-center q-mb-sm">Przeciągnij pliki tutaj</div>
        </slot>

        <div
            v-if="filesToUpload.length > 0"
            class="row"
            v-for="(file, index) in filesToUpload"
            :key="index">

            <div class="col-3">
                {{file.file.name}}
            </div>

            <q-progress
                :percentage="file.progress"
                stripe
                animate
                class="q-mb-sm col-9"
                height="20px"
            >
                asdfasdf
            </q-progress>
        </div>
    </q-card>
</template>

<script>
    import QProgress from 'quasar-framework/src/components/progress/QProgress'

    export default {
        name: 'Upload',
        components: {QProgress},
        props: ['inline', 'small', 'single', 'multi', 'extensions', 'dispatch'],
        data () {
            return {
                draggingOver: false,
                defaultDispatch: 'uploadFile',
                filesToUpload: [],
            }
        },
        methods: {
            drop (e) {
                const files = [...e.dataTransfer.files]
                const newFiles = this.filterByExtensions(files)

                this.filesToUpload = [
                    ...this.filesToUpload,
                    ...newFiles,
                ]

                if (this.single) {
                    if (newFiles.length > 0) {
                        this.uploadSingle(newFiles[0])
                    }
                } else {
                    newFiles.reduce((prom, file) => {
                        return prom.then(() => {
                            return this.uploadSingle(file).then(res => {
                                this.filesToUpload = this.filesToUpload.filter(f => {
                                    return file !== f
                                })

                                return res
                            })
                        })
                    }, Promise.resolve([]))
                }
            },
            uploadSingle (file) {
                return this.$store.dispatch(this.actualDispatch, {
                    file: file.file,
                    progress: (p) => {
                        file.progress = p
                    },
                }).then((response) => {
                    this.$emit('uploaded', response)
                    return response
                }).catch((error) => {
                    this.$emit('error', error)
                })

            },
            filterByExtensions (files) {
                if ((this.extensions || []).length > 0) {
                    const lowcaseExtensions = this.extensions.map(e => e.toLowerCase())

                    return files.filter(file => {
                        return lowcaseExtensions.filter(ext => {
                            return file.name.toLowerCase().endsWith(ext)
                        }).length > 0
                    }).map(f => {
                        return {
                            file: f,
                            progress: 0,
                            id: this.$uuid()
                        }
                    })
                } else {
                    return files.map(f => {
                        return {
                            file: f,
                            progress: 0,
                            id: this.$uuid()
                        }
                    })
                }
            },
        },
        computed: {
            actualDispatch () {
                return this.dispatch || this.defaultDispatch
            },
        },
    }
</script>

<style scoped lang="scss">
    .uploadArea {
        min-height: 100px;
        width: 100%;
        border: 3px dashed gray;
        border-radius: 20px;
        margin: 5px;

        &.small {
            height: initial;
            width: initial;
        }

        &.draggingOver {
            border-color: red;
            border-width: 3px;
        }
    }
</style>